// extracted by mini-css-extract-plugin
module.exports = {"checkLabel":"jtiDWkH0whGDPYQpuAe2FQ==","icon":"+b9xJoH1Zm6i-8VVZWpugQ=="};